import { skipToken, useQuery } from '@tanstack/react-query';
import type { Polygon } from 'geojson';
import { dataApiClient } from '../../infrastructure/dataApi/client';
import { useCurrentSimDataId } from '../SimViewer/useCurrentSimDataId';

type UseReferenceAreaData = {
  isLoading: boolean;
  referenceArea: Polygon | null;
};

const useReferenceAreaData = (): UseReferenceAreaData => {
  const { currentSimDataId } = useCurrentSimDataId();

  const { data, isFetching } = useQuery({
    queryKey: ['referenceArea', currentSimDataId],
    queryFn: currentSimDataId
      ? async (): Promise<Polygon> => {
          return dataApiClient.getGeometry(currentSimDataId);
        }
      : skipToken,
    meta: { dataType: 'others' },
  });

  return { isLoading: isFetching, referenceArea: data ?? null };
};

export { useReferenceAreaData };
